import React from "react";

import "./Header.css";
import { Headphones } from 'lucide-react';

const Header = ({switcher, setSwitcher}) => {
  // 
  return (
    <div className="header">
      <div className="headerBlock">
        {" "}
        <Headphones color="#006480" size="48" />
        <div className="header__text">
          {" "}
          <h1 className="header__title">Conference demo</h1>
          <h2 className="header__info">A remarkable conference experience in a single package</h2>
        
        </div>
      </div>
      <div className="switcher">
        <div
            className={`switcher__icon icon ${switcher ? "active" : ""}`}
            onClick={() => setSwitcher(!switcher)}
          >
            <span className="icon__ball"></span>
            
          </div>
          <p className="header__mode">{switcher ? 'Voice Mode' : 'Text Mode'}</p>
        </div>
      </div>
  );
};

export default Header;
